// console.log('resources/assets/js/modules/fixed.js');
/*
|-------------------------------------------------------------------------------
| VUEX modules/FixedTables.js
|-------------------------------------------------------------------------------
| The Vuex data store for the FixedTables
*/

import FixedTablesAPI from '../api/fixed.js';

export const fixedTables = {
	/*
	Defines the state being monitored for the module.
  */
	state: {
		FixedTables: [],
		FixedTablesLoadStatus: 0,
		FixedTablesOptions: {
			departments: [],
			entities: [],
			formats: [],
			formats_int: [],
			industries: [],
			interactive_formats: [],
			languages: [],
			music: [],
			origins: [],
			speakers: [],
			styles: [],
			topics: [],
			types: [],
			usage_rights: [],
			video_features: [],
			interactive_features: [],
			release_dates: []
		}
	},

	/*
	Defines the actions used to retrieve the data.
  */
	actions: {
		loadFixedTables({ commit, state }) {
			if ([1, 2].includes(state.FixedTablesLoadStatus)) {
				return;
			}

			commit('setFixedTablesLoadStatus', 1);

			FixedTablesAPI.getFixedTables()
				.then(function (response) {
					commit('setFixedTables', response.data);
					commit('setFixedTablesOptions', response.data);
					commit('setReleaseDateOptions');
					commit('setFixedTablesLoadStatus', 2);
				})
				.catch(function () {
					commit('setFixedTables', []);
					commit('setFixedTablesLoadStatus', 3);
				});
		}
	},
	mutations: {
		setFixedTablesLoadStatus(state, status) {
			state.FixedTablesLoadStatus = status;
		},
		setFixedTables(state, FixedTables) {
			state.FixedTables = FixedTables;
		},
		setFixedTablesOptions(state, FixedTables) {
			var ftd = FixedTables.data;
			var opt = {};
			opt.departments = ftd.departments.map(opt => ({ label: opt.title, value: opt.id }));
			opt.entities = ftd.entities.map(opt => ({ label: opt.title, value: opt.id }));
			opt.formats = ftd.formats.map(opt => ({ label: opt.title, value: opt.id }));
			opt.formats_int = ftd.formats_int.map(opt => ({ label: opt.title, value: opt.id }));
			opt.industries = ftd.industries.map(opt => ({ label: opt.title, value: opt.id }));
			opt.interactive_formats = ftd.interactive_formats.map(opt => ({ label: opt.title, value: opt.id }));
			opt.languages = ftd.languages.map(opt => ({
				label: opt.description,
				sublabel: opt.code,
				value: opt.id
			}));
			opt.music = ftd.music.map(opt => ({ label: opt.title, value: opt.id }));
			opt.origins = ftd.origins.map(opt => ({ label: opt.title, value: opt.id }));
			opt.speakers = ftd.speakers.map(opt => ({ label: opt.name, value: opt.id }));
			opt.styles = ftd.styles.map(opt => ({ label: opt.title, value: opt.id }));
			opt.topics = ftd.topics.map(opt => ({ label: opt.title, value: opt.id }));
			opt.types = ftd.types.map(opt => ({ label: opt.title, value: opt.id }));
			opt.usage_rights = ftd.usage_rights.map(opt => ({ label: opt.title, value: opt.id }));
			opt.video_features = ftd.video_features.map(opt => ({ label: opt.title, value: opt.id }));
			opt.interactive_features = ftd.interactive_features.map(opt => ({ label: opt.title, value: opt.id }));
			state.FixedTablesOptions = opt;
		},
		setReleaseDateOptions(state) {
			var years = [];
			var y = '';
			for (var i = 0; i < 20; i++) {
				y = new Date().getFullYear() - i;
				years.push({ label: y.toString(), value: y + '-01-01' });
			}
			state.FixedTablesOptions.release_dates = years;
		}
	},
	getters: {
		getFixedTablesLoadStatus(state) {
			return state.FixedTablesLoadStatus;
		},
		getFixedTables(state) {
			return state.FixedTables;
		},
		getFixedTablesOptions(state) {
			return state.FixedTablesOptions;
		}
	}
};
